import type { FC } from 'react'
import type { Facet } from 'services/Search/utils/filters'

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useActiveFilters } from 'services/Search/hooks/use-active-filters'
import { facetKeyToFilter } from 'services/Search/utils/filters'
import styled from 'styled-components'
import { capitalize } from 'utils/common/capitalize'

import { FilterCount } from './FilterCount'

interface Props {
  className?: string
  facet: Facet
}

const TabTitleComponent: FC<Props> = ({ className, facet }) => {
  const { t } = useTranslation()
  const activeFilters = useActiveFilters()

  const activeFilterCount = useMemo(() => {
    const thisFilter = activeFilters.find(({ key }) => key === facet.key)
    return thisFilter?.stringValue.length || 0
  }, [activeFilters, facet.key])

  const filter = facetKeyToFilter(facet.key)

  return (
    <span className={className} data-test-id="search-filter-drawer-tab" data-filter={filter}>
      <span>
        {
          /** Title should be in plural form, eg. "Valmistajat" */
          t(capitalize(filter), { count: 2 })
        }
      </span>
      <FilterCount count={activeFilterCount} />
    </span>
  )
}

TabTitleComponent.displayName = 'TabTitle'

export const TabTitle = styled(TabTitleComponent)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',

  /* stylelint-disable-next-line selector-type-no-unknown */
  [FilterCount]: {
    marginLeft: theme.spacings.xxSmall,
  },
}))
